var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("StatusBar", { attrs: { params: this.$route.query.params } }),
      _vm.personList.length > 0
        ? _c(
            "div",
            { staticClass: "tool-list" },
            [
              _c("span", { staticClass: "mr-2" }, [
                _vm._v("共計：" + _vm._s(_vm.totalPerson) + "人"),
              ]),
              _c("CardStyle", { on: { changeStyle: _vm.changeStyle } }),
            ],
            1
          )
        : _vm._e(),
      _c("SearchBar", {
        attrs: { show: _vm.showSearchBar },
        on: {
          showSearchBar: function ($event) {
            _vm.showSearchBar = !_vm.showSearchBar
          },
          search: function ($event) {
            ;(_vm.currentPage = 1), _vm.getAppointResult()
          },
        },
        scopedSlots: _vm._u([
          {
            key: "searchItem",
            fn: function () {
              return [
                _c("el-input", {
                  staticClass: "w-100 item-bottom",
                  attrs: {
                    clearable: "",
                    placeholder: "關鍵字（姓名、Email、聯絡電話）",
                  },
                  model: {
                    value: _vm.searchCondition.Keyword,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.searchCondition,
                        "Keyword",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "searchCondition.Keyword",
                  },
                }),
                _c("el-date-picker", {
                  staticClass: "w-100 item-bottom",
                  attrs: {
                    type: "daterange",
                    clearable: "",
                    "picker-options": {
                      disabledDate: _vm.$common.disabledDateAfterToday,
                    },
                    "range-separator": "-",
                    "start-placeholder": "面談日期(起)",
                    "end-placeholder": "面談日期(迄)",
                  },
                  model: {
                    value: _vm.searchCondition.InterviewDateRange,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchCondition, "InterviewDateRange", $$v)
                    },
                    expression: "searchCondition.InterviewDateRange",
                  },
                }),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: "單位面試主管",
                    },
                    model: {
                      value: _vm.searchCondition.InterviewSupervisor,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchCondition,
                          "InterviewSupervisor",
                          $$v
                        )
                      },
                      expression: "searchCondition.InterviewSupervisor",
                    },
                  },
                  _vm._l(_vm.supervisorOptions, function (supervisor) {
                    return _c("el-option", {
                      key: supervisor.Guid,
                      attrs: { label: supervisor.Name, value: supervisor.Name },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: "HR 面試人員",
                    },
                    model: {
                      value: _vm.searchCondition.InterviewHR,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "InterviewHR", $$v)
                      },
                      expression: "searchCondition.InterviewHR",
                    },
                  },
                  _vm._l(_vm.supervisorOptions, function (supervisor) {
                    return _c("el-option", {
                      key: supervisor.Guid,
                      attrs: { label: supervisor.Name, value: supervisor.Name },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      multiple: "",
                      clearable: "",
                      placeholder: "應聘者狀態",
                    },
                    model: {
                      value: _vm.searchCondition.Status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "Status", $$v)
                      },
                      expression: "searchCondition.Status",
                    },
                  },
                  _vm._l(_vm.candidateStatusOptions, function (status) {
                    return _c("el-option", {
                      key: status.key,
                      attrs: { label: status.value, value: status.value },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      multiple: "",
                      clearable: "",
                      placeholder: "報到狀態",
                    },
                    model: {
                      value: _vm.searchCondition.OnBoard,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "OnBoard", $$v)
                      },
                      expression: "searchCondition.OnBoard",
                    },
                  },
                  _vm._l(_vm.onBoardStatusOptions, function (status) {
                    return _c("el-option", {
                      key: status.key,
                      attrs: { label: status.value, value: status.value },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      multiple: "",
                      clearable: "",
                      placeholder: "報到意願",
                    },
                    model: {
                      value: _vm.searchCondition.Intention,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "Intention", $$v)
                      },
                      expression: "searchCondition.Intention",
                    },
                  },
                  _vm._l(_vm.intentionOptions, function (status) {
                    return _c("el-option", {
                      key: status.key,
                      attrs: { label: status.value, value: status.value },
                    })
                  }),
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        {
          staticClass: "person-card-list",
          class: {
            "list-style": _vm.gridStyle == "list",
            "block-style": _vm.gridStyle == "block",
          },
        },
        _vm._l(_vm.personList, function (person, index) {
          return _c(
            "div",
            { key: index, staticClass: "person-card infinite-list-item" },
            [
              _c("PersonCard", {
                ref: "personCard",
                refInFor: true,
                attrs: { showCheckbox: true, person: person },
                on: { updatePersonList: _vm.updatePersonList },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "note",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.clickResumeNote(props)
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: {
                                  name: "color-picker-outline",
                                  fill: "#000",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "tag",
                      fn: function ({ props }) {
                        return [
                          _c("div", { staticClass: "result" }, [
                            _vm._v(_vm._s(props.ApprovalResult)),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "middleContent",
                      fn: function ({ props }) {
                        return [
                          _c("table", { staticClass: "appoint-result-table" }, [
                            _c("tr", [
                              _c("th", [_vm._v("任用部門")]),
                              _c("td", [
                                _vm._v(_vm._s(props.AppointmentDepartment)),
                              ]),
                            ]),
                            _c("tr", { staticStyle: { height: "60px" } }, [
                              _c("th", [_vm._v("任用職務")]),
                              _c("td", [_vm._v(_vm._s(props.Position))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("簽核者")]),
                              _c("td", [
                                _vm._v(" " + _vm._s(props.Approver) + " "),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("單位面試主管")]),
                              _c("td", [
                                _vm._v(_vm._s(props.InterviewSupervisor[0])),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("HR 面試人員")]),
                              _c("td", [_vm._v(_vm._s(props.InterviewHR[0]))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("面談備註")]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      props.InterviewApprovalResultRemark
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("通知錄取")]),
                              _c("td", [
                                props.HireNoticeMailTime
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$common.dateFormatter(
                                              props.HireNoticeMailTime
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c("span", [_vm._v("尚未")]),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("通知報到")]),
                              _c("td", [
                                props.ReportNoticeMailTime
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$common.dateFormatter(
                                              props.ReportNoticeMailTime
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c("span", [_vm._v("尚未")]),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("報到意願")]),
                              _c(
                                "td",
                                [
                                  props.OnBoardIntentionReason
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              props.OnBoardIntentionReason,
                                            placement: "right",
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(props.OnBoardIntention) +
                                                " "
                                            ),
                                          ]),
                                        ]
                                      )
                                    : [
                                        _vm._v(
                                          " " +
                                            _vm._s(props.OnBoardIntention) +
                                            " "
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("報到狀態")]),
                              _c("td", [
                                _vm._v(" " + _vm._s(props.OnBoard) + " "),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("智財變更註記")]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      props.IPChangeTag === true ? "是" : "否"
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "buttonGroup",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "el-dropdown",
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "el-dropdown-link",
                                  attrs: { type: "button" },
                                },
                                [
                                  _vm._v(" 檢視資訊"),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down el-icon--right",
                                  }),
                                ]
                              ),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showDetailModal(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" 檢視履歷 ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showProgressRecord(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" 檢視歷程 ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          props.ApprovalResult === "通過" &&
                          props.OnBoard === "待報到"
                            ? [
                                _c(
                                  "el-dropdown",
                                  { staticClass: "mr-1" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "el-dropdown-link",
                                        attrs: { type: "button" },
                                      },
                                      [
                                        _vm._v(" 通知信"),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-arrow-down el-icon--right",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown",
                                      },
                                      [
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.sendMail(
                                                  props,
                                                  "hire"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 錄取通知 ")]
                                        ),
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.sendMail(
                                                  props,
                                                  "report"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 報到通知 ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                props.ReportNoticeMailTime ||
                                props.ReportNoticeMailTime
                                  ? _c(
                                      "el-dropdown",
                                      { staticClass: "mr-1" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "el-dropdown-link",
                                            attrs: { type: "button" },
                                          },
                                          [
                                            _vm._v(" 人事資料"),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-arrow-down el-icon--right",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    _vm.$router.push({
                                                      path:
                                                        props.ResumeType ===
                                                        "IDL"
                                                          ? "/manager/form/idl/personnelinformation"
                                                          : "/manager/form/dl/personnelinformation",
                                                      query: {
                                                        matchId: `${props.MatchId}`,
                                                        personData:
                                                          JSON.stringify({
                                                            Name: person.Name,
                                                            Position:
                                                              person.Position,
                                                          }),
                                                      },
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v(" 人事資料表 ")]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.clickHcpData(
                                                      props
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" HCP人事資料維護 ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          props.ReportNoticeMailTime
                            ? _c(
                                "button",
                                {
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openOnBoardModal(props)
                                    },
                                  },
                                },
                                [_vm._v(" 報到確認 ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm.personList.length > 0
        ? _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next",
              total: _vm.totalPerson,
              "page-size": 9,
            },
            on: { "current-change": _vm.changePage },
          })
        : _vm._e(),
      _c("ResumeNoteModal", { attrs: { personData: _vm.interviewee } }),
      _c("ActionBar", {
        staticStyle: { "z-index": "10000" },
        attrs: {
          show: _vm.showActionBar,
          totalPerson: _vm.totalPerson,
          selectedCardList: _vm.choosePersonList,
        },
        on: {
          showActionBar: function ($event) {
            _vm.showActionBar = !_vm.showActionBar
          },
          selectAllCards: _vm.selectAllCards,
          clearSelectCard: _vm.clearSelectCard,
        },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function () {
              return [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.exportOffer },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { name: "download-outline", fill: "#FFF" },
                    }),
                    _c("span", [_vm._v("下載 Offer")]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("HireMailModal", {
        attrs: { personData: _vm.personData },
        on: { updatePerson: _vm.updatePerson },
      }),
      _c("ReportMailModal", {
        attrs: { personData: _vm.personData },
        on: { updatePerson: _vm.updatePerson },
      }),
      _c("HcpDataModal", { attrs: { personData: _vm.personData } }),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "checkOnBoardModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog" },
            [
              _c("img", {
                staticClass: "cord",
                attrs: {
                  src: require("@/assets/img/name_card_cord.png"),
                  alt: "",
                },
              }),
              _c("ValidationObserver", {
                ref: "reported",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ handleSubmit, reset }) {
                      return [
                        _c(
                          "form",
                          {
                            on: {
                              reset: function ($event) {
                                $event.preventDefault()
                                return reset.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "modal-content" }, [
                              _c("div", { staticClass: "modal-header" }, [
                                _c("span", [_vm._v("完成報到")]),
                              ]),
                              _c("div", { staticClass: "modal-body" }, [
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "text-wrap" }, [
                                    _c("div", { staticClass: "name" }, [
                                      _vm._v(_vm._s(_vm.person.Name)),
                                    ]),
                                    _c("div", { staticClass: "position" }, [
                                      _vm._v(_vm._s(_vm.person.Position)),
                                    ]),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "state-wrap" },
                                  [
                                    _c("ValidationProvider", {
                                      staticClass: "w-100",
                                      attrs: { tag: "div", rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-check form-check-inline",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.person
                                                              .OnBoardStatus,
                                                          expression:
                                                            "person.OnBoardStatus",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-check-input",
                                                      attrs: { type: "radio" },
                                                      domProps: {
                                                        value: 0,
                                                        checked: _vm._q(
                                                          _vm.person
                                                            .OnBoardStatus,
                                                          0
                                                        ),
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            _vm.person,
                                                            "OnBoardStatus",
                                                            0
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-check-label",
                                                        attrs: { for: "" },
                                                      },
                                                      [_vm._v(" 待報到 ")]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-check form-check-inline",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.person
                                                              .OnBoardStatus,
                                                          expression:
                                                            "person.OnBoardStatus",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-check-input",
                                                      attrs: { type: "radio" },
                                                      domProps: {
                                                        value: 1,
                                                        checked: _vm._q(
                                                          _vm.person
                                                            .OnBoardStatus,
                                                          1
                                                        ),
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            _vm.person,
                                                            "OnBoardStatus",
                                                            1
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-check-label",
                                                        attrs: { for: "" },
                                                      },
                                                      [_vm._v(" 完成報到 ")]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-check form-check-inline",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.person
                                                              .OnBoardStatus,
                                                          expression:
                                                            "person.OnBoardStatus",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-check-input",
                                                      attrs: { type: "radio" },
                                                      domProps: {
                                                        value: -99,
                                                        checked: _vm._q(
                                                          _vm.person
                                                            .OnBoardStatus,
                                                          -99
                                                        ),
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            _vm.person,
                                                            "OnBoardStatus",
                                                            -99
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-check-label",
                                                        attrs: { for: "" },
                                                      },
                                                      [_vm._v(" 取消報到 ")]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-check form-check-inline",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.person
                                                              .OnBoardStatus,
                                                          expression:
                                                            "person.OnBoardStatus",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-check-input",
                                                      attrs: { type: "radio" },
                                                      domProps: {
                                                        value: -1,
                                                        checked: _vm._q(
                                                          _vm.person
                                                            .OnBoardStatus,
                                                          -1
                                                        ),
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            _vm.person,
                                                            "OnBoardStatus",
                                                            -1
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-check-label",
                                                        attrs: { for: "" },
                                                      },
                                                      [_vm._v(" 延期報到 ")]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "text-danger",
                                                    staticStyle: {
                                                      "font-size": "13px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm.person.OnBoardStatus === 1 ||
                                _vm.person.OnBoardStatus === -1
                                  ? _c(
                                      "div",
                                      { staticClass: "number-wrap" },
                                      [
                                        _c("ValidationProvider", {
                                          staticClass: "w-100",
                                          attrs: {
                                            tag: "div",
                                            rules: "required",
                                            name: "報到日期",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("el-date-picker", {
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        type: "date",
                                                        "value-format":
                                                          "yyyy-MM-dd",
                                                        "picker-options": {
                                                          disabledDate:
                                                            _vm.$common
                                                              .disabledDateBeforeToday,
                                                        },
                                                        placeholder:
                                                          "請選擇日期",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.person
                                                            .NewOnBoardDate,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.person,
                                                            "NewOnBoardDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "person.NewOnBoardDate",
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm.person.OnBoardStatus === -99
                                  ? _c(
                                      "div",
                                      [
                                        _c("ValidationProvider", {
                                          staticClass: "w-100",
                                          attrs: {
                                            tag: "div",
                                            rules: "required",
                                            name: "原因",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function ({ errors }) {
                                                  return [
                                                    _c("el-cascader", {
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        options:
                                                          _vm.notArrivedCategoryOptions,
                                                        clearable: "",
                                                        "show-all-levels": true,
                                                        placeholder:
                                                          "請選擇原因",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.person
                                                            .notArrivedCategory,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.person,
                                                            "notArrivedCategory",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "person.notArrivedCategory",
                                                      },
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.person.OnBoardRemark,
                                              expression:
                                                "person.OnBoardRemark",
                                            },
                                          ],
                                          staticClass: "form-control w-100",
                                          attrs: {
                                            type: "text",
                                            rows: "3",
                                            maxlength: "200",
                                            placeholder: "請輸入備註",
                                          },
                                          domProps: {
                                            value: _vm.person.OnBoardRemark,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.person,
                                                "OnBoardRemark",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "modal-footer" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "reset",
                                      "aria-label": "關閉",
                                      "data-dismiss": "modal",
                                    },
                                  },
                                  [_vm._v(" 取消 ")]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return handleSubmit(
                                          _vm.confirmedOnBoard
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" 確認 ")]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _vm.isShowDetail
            ? _c("div", { staticClass: "detail-modal" }, [
                _c("div", { staticClass: "detail-modal-inner" }, [
                  _c("div", { staticClass: "menu" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.detailCurrentPage = 0
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: { name: "person-outline", fill: "#FFF" },
                            }),
                            _vm._v(" 履歷 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.detailCurrentPage = 1
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: {
                                name: "message-circle-outline",
                                fill: "#FFF",
                              },
                            }),
                            _vm._v(" 面談紀錄 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.detailCurrentPage = 2
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: {
                                name: "clipboard-outline",
                                fill: "#FFF",
                              },
                            }),
                            _vm._v(" 任用單 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "close-show-detail",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.isShowDetail = !_vm.isShowDetail
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: {
                            name: "close-circle",
                            fill: "#FFF",
                            width: "50",
                            height: "50",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "page-wrap" },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 0
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("履歷")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "item text-right" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-primary btn-sm",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$common.downloadResumePDF(
                                                      _vm.ResumeType,
                                                      _vm.ResumeId
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 下載 PDF ")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.ResumeType === "IDL"
                                      ? _c("IdlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.ResumeType === "DL"
                                      ? _c("DlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 1
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("面談紀錄")]
                                        ),
                                        _c("div", { staticClass: "item" }),
                                      ],
                                      1
                                    ),
                                    _c("InterviewRecord", {
                                      attrs: { MatchId: _vm.MatchId },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 2
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("任用單")]
                                        ),
                                        _c("div", { staticClass: "item" }),
                                      ],
                                      1
                                    ),
                                    _c("AppointmentRecord", {
                                      attrs: { MatchId: _vm.MatchId },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c("ProgressRecordModal", {
        attrs: { Name: _vm.Name, UserId: _vm.UserId, Email: _vm.Email },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }